import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setDeviceEmpty } from "../../../testActions";
import { store } from "../../../testStore";
import { withRouter } from 'react-router-dom';
import { S } from '../../../routes/routes';
import { setDeviceCategoryPayload } from "../../../testActions";
import Select from 'react-select';
import { Card, CardBody, Row } from 'reactstrap';
import Button from '@material-ui/core/Button';
import { SubViewHeaderStep } from '../../../lib/components/subHeader';
import { safeDeepGet } from 'iotera-base/json';

class CategoriesCards extends Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(type, category) {
    let submitData = { category, type }
    let action = setDeviceCategoryPayload(submitData);
    store.dispatch(action)
    this.props.history.push('.' + S + 'info')
  }

  render() {
    const _this = this
    const _props = _this.props
    let userCards = []
    _props.data.forEach((category, index) => {
      userCards.push(
        <div className="col-md-3" style={{ paddingLeft: 0, paddingRight: 0, marginBottom: 10 }} key={index}>
          <div className="container" style={{ paddingRight: 5, paddingLeft: 5 }}>
            <Card className="cardsss" style={{ backgroundColor: '#ffffff', borderWidth: 0, padding: '10px 0px' }}>
              <CardBody className="d-flex align-items-center flex-column" style={{ padding: 10 }}>
                <Row style={{ margin: '20px 0px' }}>
                  <img src={category.pict} alt="Device Type"
                    style={{ height: 64 }} />
                </Row>
                <div style={{ width: '100%', height: 1, backgroundColor: '#E2E2E2', marginTop: 10, marginBottom: 15 }} />
                <div className='centeringItem'>{category.title}</div>
              </CardBody>
            </Card>
            <div className="middle">
              <Row >
                <div className="col-md-12">
                  <button className="button-iotera-primary-outline"
                    onClick={(e) => _this.handleSelect(category.value, category.category)}>Pilih</button>
                </div>
              </Row>
            </div>
          </div>
        </div>
      )
    });
    return (
      <Row style={{ margin: '10px -5px' }}>
        {userCards}
      </Row>
    )
  }
}

class Example extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filter: false,
      categoryList: props.items,
      loading: false,
      filters: {
        category: []
      },
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
  }

  goTo(link) {
    let action = setDeviceEmpty();
    store.dispatch(action)
    this.props.history.push(link)
  }

  handleFilter = (value, action) => {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    if (value === null) {
      _this.setState({ filter: false });
      return;
    }
    let newState = Object.assign({}, _state);
    let filters = []
    value = [value];
    value.forEach((filter) => {
      filters.push(filter.value)
    })
    newState.filters['category'] = filters;
    let filter = newState.filters;
    let finalFilter = true;
    let data = safeDeepGet(_props, ['items']);
    if (filter.category.length === 0) {
      finalFilter = false;
    }
    if (finalFilter) {
      if (value !== null) {
        if (value[0].value === 'all') {
          this.setState({ categoryList: data, filter: finalFilter });
        } else {
          // SIMPLIFIED
          let deviceToShow = data.filter(
            d =>
              filter.category.every(r => d.category.indexOf(r) >= 0)
          )
          _this.setState({ categoryList: deviceToShow, filter: finalFilter });
        }
      }
    } else {
      _this.setState({ filter: finalFilter });
    }
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let dropdownItem = []
    let data = safeDeepGet(_props, ['items']);
    const { filter, categoryList } = _state
    if (filter) {
      data = categoryList
    }
    let allItem = []
    Object.keys(_props.items).forEach((key) => {
      allItem.push(_props.items[key]['category'])
    })
    allItem = [].concat.apply([], allItem);
    allItem = [...new Set(allItem)];
    for (let j = 0; j < allItem.length; j++) {
      let name = allItem[j];
      if (name === 'ethernet') {
        name = 'Ethernet'
      } else if (name === 'wifi') {
        name = 'WiFi'
      } else if (name === 'lorawan') {
        name = 'LoRaWAN'
      } else if (name === 'zlan') {
        name = 'ZLAN'
      } else if (name === 'usr-iot') {
        name = 'USR IOT'
      } else if (name === 'bivocom') {
        name = 'Bivocom'
      } else if (name === 'friendcom') {
        name = 'Friendcom'
      } else if (name === 'mqtt') {
        name = 'MQTT'
      } else if (name === 'iotera') {
        name = 'Iotera'
      } else if (name === 'imou_camera') {
        name = 'Imou Camera'
      }
      dropdownItem.push(
        { label: name, value: allItem[j] },
      )
    }
    return (
      <div className="view">
        <SubViewHeaderStep title='Tambah Perangkat' subTitle='Permohonan tambah perangkat baru' 
        steps={['Kategori', 'Informasi', 'Aktivasi']} activeStep={0} />
        <div className="io-container mt-12">
          <div>
            <Select styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} menuPortalTarget={document.body}
              ref="selectComponent"
              closeMenuOnSelect={true}
              defaultValue={[]}
              isClearable
              placeholder="Filter"
              name="colors"
              isMulti={false}
              options={dropdownItem}
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={_this.handleFilter}
            />
          </div>
          <CategoriesCards {..._props} data={data} />
          <div className="button-right" >
            <Button variant="outlined" size="large" style={{ minWidth: '0%' }} 
            onClick={(e) => _this.goTo('..' + S + '_device_list_')} >Batal</Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    items: [
      { title: 'Dummy', value: 'DUMMY', pict: 'https://i.imgur.com/E88sEIHl.png', category: [] },
      // { title: 'Raspberry Pi', value: 'rasp-pi', pict: 'https://i.imgur.com/iWxwD5Jl.png', category: ['ethernet', 'wifi'] },
      { title: 'Iotera Industrial Gateway', value: 'IOTERA_INDUSTRIAL_GATEWAY', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['iotera'] },
      { title: 'Iotera Compute Unit', value: 'IOTERA_COMPUTE_UNIT', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['iotera'] },
      { title: 'Iotera Sensor Node', value: 'IOTERA_SENSOR_NODE', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['iotera'] },
      { title: 'Iotera Android Station', value: 'IOTERA_ANDROID_STATION', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['iotera'] },
      { title: 'Iotera LoRa Sensor Node', value: 'IOTERA_LORA_SENSOR_NODE', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['lorawan'] },
      // { title: 'Four Faith F8L10T-N', value: 'FOUR_FAITH_F8L10T_N', pict: 'https://i.imgur.com/rjQM5lLl.png', category: ['lorawan'] },
      // { title: 'Four Faith F8L10T-E', value: 'FOUR_FAITH_F8L10T_E', pict: 'https://i.imgur.com/rjQM5lLl.png', category: ['lorawan'] },
      // { title: 'Digital Matter Oyster', value: 'DIGITAL_MATTER_OYSTER', pict: 'https://i.imgur.com/ytA1Ettl.png', category: ['lorawan'] },
      // { title: 'Digital Matter Guppy', value: 'DIGITAL_MATTER_GUPPY', pict: 'https://i.imgur.com/LQCKR9Cl.png', category: ['lorawan'] },
      // { title: 'Digital Matter Sensor Node', value: 'DIGITAL_MATTER_SENSOR_NODE', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['lorawan'] },
      // { title: 'Digital Matter G62', value: 'DIGITAL_MATTER_G62', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['lorawan'] },
      // { title: 'DDS155 BR Single Phase', value: 'DDS155_BR_SINGLE_PHASE', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['lorawan'] },
      // { title: 'ZLAN 6844N', value: '6844N', pict: 'https://i.imgur.com/aRsYeSyl.png', category: ['zlan'] },
      { title: 'USR-IO424T (EWR)', value: 'USR_IO424T_EWR', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['usr-iot'] },
      // { title: 'Bivocom TW810-M', value: 'BIVOCOM_TW810_M', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['bivocom'] },
      { title: 'Friendcom FC722 NBIOT', value: 'FRIENDCOM_NBIOT', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['friendcom'] },
      { title: 'MQTT', value: 'MQTT', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['mqtt'] },
      { title: 'Tasmota', value: 'TASMOTA_SONOFF_BASIC', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['tasmota'] },
      { title: 'Emma', value: 'EMMA', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['emma'] },
      { title: 'Imou Camera', value: 'IMOU_CAMERA', pict: 'https://i.imgur.com/E88sEIHl.png', category: ['imou_camera'] }
    ]
  }
}

export default connect(mapStateToProps)(withRouter(Example));